import { Stack, Typography } from '@mui/material'
import { ReactNode } from 'react'

export const LabeledValue = ({ label, children }: { label: string; children: ReactNode }) => (
  <Stack direction="column" alignItems="flex-start">
    <Typography
      component="label"
      variant="caption"
      textTransform="uppercase"
      fontWeight={600}
      color="textSecondary"
      lineHeight={1.1}
    >
      {label}
    </Typography>
    {children}
  </Stack>
)
